import React from "react";
import { ChargeType } from "Util/Enum";
import { Div, Img, Txt } from "Components/GenericView";

const ChargeItem: React.FunctionComponent<any> = ({
  setShowChargeDetails,
  itemArray,
}) => {
  const data = itemArray[0];
  const charge_status = data?.charge_status;
  const type = data?.type;
  const renderSingleCell = () => (
    <Div
      mt={4}
      p={"13px 11px 10px 15px"}
      br={8}
      className="flex justify-between wa-tr-item center pointer"
      onClick={() => setShowChargeDetails(data)}
    >
      <Div relative>
        <Txt color="#22234E" fs={14}>
          {data.is_cancelled && type !== "ca"
            ? "Cancellation Fee"
            : data.is_refund && type !== "ca"
            ? "Visit Refund"
            : ChargeType[type]}
          {charge_status === "failed" && (
            <Txt
              inline
              color="#E01A4F"
              fs={11}
              br={4}
              p="1px 6px"
              bg="#FFF6F8"
              absT={-1}
              ml={3}
            >
              Failed
            </Txt>
          )}
        </Txt>

        {type === "package" && (
          <Txt color="#9898A6" fs={12} mt={4}>
            {data.package_category}
            <Txt
              color="#32BDC7"
              bg="rgba(50,189,199,0.18)"
              br={6}
              fs={11}
              inline
              ml={8}
              p="3.0px 5.6px"
            >
              {data.package_length}
            </Txt>
          </Txt>
        )}
        {type === "ca" && data.is_cancelled && (
          <Txt color="#9898A6" fs={12} mt={4}>
            Cancelled
          </Txt>
        )}
        {(type === "visit" || type === "teleconsult" || type === "ca") &&
          data.visit_time && (
            <Txt color="#9898A6" fs={12} mt={4}>
              <Img size={8.6} src="/self-serve/time@3x.png" mr={6} />
              {data.visit_time}
            </Txt>
          )}
      </Div>
      <Div
        bg={charge_status === "completed" ? "#F1F8F8" : "#F8F8F8"}
        br={6}
        p="15px 16px 14px 18px"
        relative
        textAlign="center"
        color={data.is_refund ? "#7ED321" : "#22234E"}
        width={115}
      >
        <Img
          size={19}
          src={
            data.is_refund
              ? "/self-serve/debit@3x.png"
              : charge_status === "completed"
              ? "/self-serve/credit@3x.png"
              : "/self-serve/credit-pending@3x.png"
          }
          absL={-9}
          absB={
            charge_status === "upcoming" && data.type === "teleconsult"
              ? 25
              : 13
          }
        />
        <Txt fs={13}>
          {data.amount
            ? data.currency === "h"
              ? data.amount + data.currency
              : `${data.currency} ${data.amount}`
            : data.visit_duration}
        </Txt>
        {charge_status === "upcoming" && data.type === "teleconsult" && (
          <Txt fs={11}>& other charges if applicable</Txt>
        )}
      </Div>
    </Div>
  );

  // For rendering group items
  const renderGroupItem = (itemData: any, index: number) => (
    <Div
      key={index + itemData.visit_id}
      className="flex justify-between pointer center wa-tr"
      onClick={() => setShowChargeDetails(itemData)}
      p={"13px 11px 10px 15px"}
    >
      <Div relative>
        <Txt color="#9898A6" fs={14}>
          {itemData.is_refund && itemData.is_cancelled
            ? "Cancelled"
            : itemData.is_refund
            ? "Visit Refund"
            : `Charged with ${
                itemData.packages_used
                  ? "package"
                  : itemData?.payment_method?.method
              }`}
          {charge_status === "failed" && (
            <Txt
              inline
              color="#E01A4F"
              fs={11}
              br={4}
              p="1px 6px"
              bg="#FFF6F8"
              absT={-1}
              ml={3}
            >
              Failed
            </Txt>
          )}
        </Txt>

        {itemData.is_cancelled && (
          <Txt color="#9898A6" fs={12} mt={4}>
            Cancelled
          </Txt>
        )}
      </Div>
      <Div
        bg={charge_status === "completed" ? "#F1F8F8" : "#F8F8F8"}
        br={6}
        p="15px 16px 14px 18px"
        relative
        textAlign="center"
        color={itemData.is_refund ? "#7ED321" : "#22234E"}
        width={115}
      >
        <Img
          size={19}
          src={
            itemData.is_refund
              ? "/self-serve/debit@3x.png"
              : charge_status === "completed"
              ? "/self-serve/credit@3x.png"
              : "/self-serve/credit-pending@3x.png"
          }
          absL={-9}
          absB={
            charge_status === "upcoming" && itemData.type === "teleconsult"
              ? 25
              : 13
          }
        />
        <Txt fs={13}>
          {itemData.amount
            ? itemData.currency === "h"
              ? itemData.amount + itemData.currency
              : `${itemData.currency} ${itemData.amount}`
            : itemData.visit_duration}
        </Txt>
        {charge_status === "upcoming" && itemData.type === "teleconsult" && (
          <Txt fs={11}>& other charges if applicable</Txt>
        )}
      </Div>
    </Div>
  );
  const renderMultipleCell = () => (
    <Div mt={4} br={8} className="wa-tr-item center">
      <Div
        className="flex justify-between pointer"
        onClick={() => setShowChargeDetails(data)}
        p={"13px 11px 10px 15px"}
      >
        <Div relative>
          <Txt color="#22234E" fs={14}>
            {data.is_cancelled && type !== "ca"
              ? "Cancellation Fee"
              : data.is_refund && type !== "ca"
              ? "Visit Refund"
              : ChargeType[type]}
            {charge_status === "failed" && (
              <Txt
                inline
                color="#E01A4F"
                fs={11}
                br={4}
                p="1px 6px"
                bg="#FFF6F8"
                absT={-1}
                ml={3}
              >
                Failed
              </Txt>
            )}
          </Txt>

          {type === "package" && (
            <Txt color="#9898A6" fs={12} mt={4}>
              {data.package_category}
              <Txt
                color="#32BDC7"
                bg="rgba(50,189,199,0.18)"
                br={6}
                fs={11}
                inline
                ml={8}
                p="3.0px 5.6px"
              >
                {data.package_length}
              </Txt>
            </Txt>
          )}

          {type === "visit" && (
            <Txt color="#9898A6" fs={12} mt={4}>
              <Img size={8.6} src="/self-serve/time@3x.png" mr={6} />
              {data.visit_time}
            </Txt>
          )}
        </Div>
        {data.is_refund && (
          <Div
            bg={charge_status === "completed" ? "#F1F8F8" : "#F8F8F8"}
            br={6}
            p="15px 16px 14px 18px"
            relative
            textAlign="center"
            color={data.is_refund ? "#7ED321" : "#22234E"}
            width={115}
          >
            <Img
              size={19}
              src={
                data.is_refund
                  ? "/self-serve/debit@3x.png"
                  : charge_status === "completed"
                  ? "/self-serve/credit@3x.png"
                  : "/self-serve/credit-pending@3x.png"
              }
              absL={-9}
              absB={
                charge_status === "upcoming" && data.type === "teleconsult"
                  ? 25
                  : 13
              }
            />
            <Txt fs={13}>
              {data.amount
                ? data.currency === "h"
                  ? data.amount + data.currency
                  : `${data.currency} ${data.amount}`
                : data.visit_duration}
            </Txt>
            {charge_status === "upcoming" && data.type === "teleconsult" && (
              <Txt fs={11}>& other charges if applicable</Txt>
            )}
          </Div>
        )}
      </Div>
      {itemArray
        .filter((ele: any) => !!ele.packages_used)
        .map((itemData: any, index: number) => {
          return renderGroupItem(itemData, index);
        })}
      {itemArray
        .filter((ele: any) => !!ele.payment_method)
        .map((itemData: any, index: number) => {
          return renderGroupItem(itemData, index);
        })}
    </Div>
  );
  return (
    <Div>
      {itemArray?.length === 1 ? renderSingleCell() : renderMultipleCell()}
    </Div>
  );
};

export default ChargeItem;
